import { render, staticRenderFns } from "./ManageWait.vue?vue&type=template&id=51bcd07f&scoped=true"
import script from "./ManageWait.vue?vue&type=script&lang=js"
export * from "./ManageWait.vue?vue&type=script&lang=js"
import style0 from "./ManageWait.vue?vue&type=style&index=0&id=51bcd07f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51bcd07f",
  null
  
)

export default component.exports